<script setup>
import {ref} from 'vue'

//Emits and props
defineEmits([
  'click',
])
defineProps({
  isHeader: {
    type: Boolean,
    default: false,
  },
})

//Hover flag
const hover = ref(false)
</script>

<template>
  <tr
    :class="{
      [$style.row]: true,
      [$style.header]: isHeader,
    }"
    :data-header="isHeader"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
    @click="$emit('click', $event)"
  >
    <slot :hover="hover" />
  </tr>
  <tr
    v-if="$slots.expandedContent"
    :class="$style.expandedRow"
  >
    <td :colspan="100">
      <div :class="$style.expandedContent">
        <slot name="expandedContent" />
      </div>
    </td>
  </tr>
</template>

<style module lang="scss">
.row {
  background-color: transparent;
  transition: background-color ease-in-out .2s;
  color: inherit;

  &:hover {
    background-color: var(--bg-panels);
  }
}
.expandedRow {
  background-color: var(--bg-panels);
}
.expandedContent {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
</style>
